import { LinhaVenda } from '@shared/models';
import { Component, OnInit } from '@angular/core';
import { ClientesService } from '@modules/clientes/services/clientes.service';

interface ClienteMostruarioIdealDTO {
  id: number,
  razaoSocial: string,
  cnpj: string,
  setorCdfzs: string,
}

interface ParametrosMostruarioIdealModal {
  cliente: ClienteMostruarioIdealDTO,
  linhas: LinhaVenda[]
}

@Component({
  selector: 'app-mostruario-ideal',
  templateUrl: './mostruario-ideal-modal.component.html',
  styleUrls: ['./mostruario-ideal-modal.component.css']
})
export class MostruarioIdealModalComponent implements OnInit {
  linhaVendaSelecionada: LinhaVenda = null;
  lsMostruarioIdeal = []
  linhasVenda = [];

  cliente: ClienteMostruarioIdealDTO = null;

  loading = false;

  constructor(
    private clientService:  ClientesService
  ) { }

  ngOnInit() {
  }

  openModal(params: ParametrosMostruarioIdealModal){
    this.cliente = params.cliente;
    this.linhasVenda = params.linhas;
    this.linhaVendaSelecionada = this.linhasVenda[0]

    document.getElementById("openMostruarioIdealButton").click();

    this.getMostruarioIdeal()
  }

  openHistoricoFaturamentoModal(){

  }

  handleLineChange(){
    this.getMostruarioIdeal();
  }

  getMostruarioIdeal(){
    this.loading = true;

    this.clientService.getMostruarioIdeal(this.cliente.id, this.linhaVendaSelecionada.descricao)
      .finally(() => (this.loading = false))
      .subscribe(
        data => this.lsMostruarioIdeal = this.agruparMostruarioIdeal(data),
        error => console.log(error)
      );

  }

  resetModal(){
    this.cliente = null;
    this.lsMostruarioIdeal = []
  }

  // Metodos privados

  private agruparMostruarioIdeal(data){
    const mostruarioIdeal = {};

    data.map(item => {
      if(mostruarioIdeal[item.segmento]){
        mostruarioIdeal[item.segmento].items.push(item)
        mostruarioIdeal[item.segmento].quantidadeFaturada += item.quantidadeFaturada
      }else{
          mostruarioIdeal[item.segmento] = {
          items:[item],
          quantidadeFaturada:item.quantidadeFaturada,
        };
      }
    })

    const listaMostruarioIdeal = [];

    Object.keys(mostruarioIdeal).map(key => {
      listaMostruarioIdeal.push({
        ...mostruarioIdeal[key],
        segment:key
      })
    })

    return listaMostruarioIdeal;
  }
}
